import React, { useEffect, useState } from "react";
import {
  AllTabType,
  IHomecareAppointDetail,
  IHomeCareProductDocument,
} from "src/types/GlobalInterfaces";
import HomeCareAppSection from "./HomeCareAppSection";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import moment from "moment";
import {
  appointmentSlots,
  generateDynamicSlots,
  IDynamicSlot,
  IOrganizedSlots,
} from "src/lib/constans";
import BookHomeCareSection from "./BookHomeCareSection";
import { decodedToken } from "src/helpers/helperFunctions";

interface IProps {
  id: string;
  onBack: () => void;
  onSuccess: () => void;
  userRole?: "customer" | "admin";
  isEdit?: boolean;
  editData?: IHomecareAppointDetail | null;
}

const HomeCareAppointementScreen = ({ id, onBack, onSuccess, userRole = "customer", isEdit = false, editData = null }: IProps) => {
  const [activeTab, setActiveTab] = useState<AllTabType>("HomeCareAppointment");
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<any>(null);
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const handleTabChange = (tab: AllTabType) => {
    setActiveTab(tab);
  };
  const [datesRange, setDatesRange] = useState<
    { date: string; count: number }[]
  >([]);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<IDynamicSlot | null>(null);
  const fetchById = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IHomeCareProductDocument>({
      path: `/home-care-services/home/${id}?userId=${decodedToken()?.id || ""}`,
    });
    if (res) {
      setData(res);
      let dateArray = getDatesRange(res);
      setDatesRange(dateArray);
      setSelectedDate(dateArray[0].date);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const getSlotsCount = (date: string, d: IHomeCareProductDocument) => {
    if (date) {
      let duration = d?.serviceDuration
        ? parseInt(d?.serviceDuration)
        : 1;
      let slots = generateDynamicSlots(duration, date, editData);
      let count = 0;
      let slts = [
        ...slots.morning,
        ...slots.afternoon,
        ...slots.evening,
        ...slots.night,
      ];
      slts.forEach((slot: IDynamicSlot) => {
        if (slot.isPassed || slot.afterOneHours || slot.isAlreadySelected) {
          return;
        }
        count = count + 1;
      });
      return count;
    }
  };

  const getDatesRange = (d: IHomeCareProductDocument) => {
    const currentDate = moment(); // Get today's date
    const dateArray = [];
    for (let i = 0; i < 15; i++) {
      dateArray.push(
        currentDate
          .clone()
          .add(i, "days")
          .set("hour", 6)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0)
          .toISOString()
      );
    }
    return dateArray.map((date) => ({ date, count: getSlotsCount(date, d) || 0 }));
  };

  useEffect(() => {
    if (!id) return;
    fetchById();
  }, [id]);
  
  useEffect(() => {
    let interval = setInterval(() => {
      let darry = getDatesRange(data);
      setDatesRange(darry);
    }, 5000);
    return () => clearInterval(interval);
  }, [data]);

  useEffect(() => {
    setSelectedSlot(null);
  }, [selectedDate]);

  return (
    <>
      {activeTab === "HomeCareAppointment" && (
        <HomeCareAppSection
          data={data}
          datesRange={datesRange}
          selectedDate={selectedDate || ""}
          setSelectedDate={setSelectedDate}
          loading={isLoader}
          selectedSlot={selectedSlot || null}
          setSelectedSlot={setSelectedSlot}
          onBack={onBack}
          setActiveTab={setActiveTab}
          isEdit={isEdit}
          editData={editData}
        />
      )}
      {activeTab === "BookHomeCare" && (
        <BookHomeCareSection
          data={data}
          onBack={() => setActiveTab("HomeCareAppointment")}
          selectedDate={selectedDate || ""}
          selectedSlot={selectedSlot || null}
          onSuccess={() => {
            onSuccess?.();
          }}
        />
      )}
    </>
  );
};

export default HomeCareAppointementScreen;
